// Firefox sets window.localStorage to null when cookies/storage are disabled,
// unlike Chrome which throws a SecurityError. This wrapper prevents
// "Cannot read properties of null" errors in those environments.
//
// Uses lazy access so tests that mock globalThis.localStorage still work.

export const safeStorage = {
  getItem(key: string): string | null {
    try {
      return globalThis.localStorage?.getItem(key) ?? null;
    } catch {
      return null;
    }
  },
  setItem(key: string, value: string): void {
    try {
      globalThis.localStorage?.setItem(key, value);
    } catch {
      // storage unavailable
    }
  },
  removeItem(key: string): void {
    try {
      globalThis.localStorage?.removeItem(key);
    } catch {
      // storage unavailable
    }
  },
};
